import { calendarInitilaizerFactory } from "common/calendar";
import TimeSlotsCalendar from "./TimeSlotsCalendar";

function requireAll(r) {
  r.keys().forEach(r);
}

requireAll(require.context("./", true, /\.js$/));

calendarInitilaizerFactory({
  component: TimeSlotsCalendar,
  target: ".js-daily-time-slot-events-calendar",
});
